import { Reveal } from "@/components/Reveal";
import { motion } from "framer-motion";
import { stagger, fadeUp, viewportOnce } from "@/lib/motion";
import { WHY } from "@/data/content";

const WhyChoose = () => {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative bg-ivory py-28 md:py-40 scroll-mt-24"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-4">
          <Reveal>
            <p className="kicker text-gold mb-6">Why Svara Chakra</p>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="font-serif font-light text-charcoal text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              A different kind of wellness.
            </h2>
          </Reveal>
          <Reveal delay={0.14}>
            <p className="mt-8 text-charcoal/70 leading-relaxed max-w-sm">
              Considered, intimate and quietly transformative — built for people
              who value depth over noise.
            </p>
          </Reveal>
        </div>

        <motion.div
          variants={stagger(0.1, 0.14)}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-x-12 gap-y-14"
        >
          {WHY.map((item, i) => (
            <motion.div key={i} variants={fadeUp} className="group">
              <div className="flex items-baseline gap-4 mb-4">
                <span className="font-serif text-gold text-2xl">0{i + 1}</span>
                <div className="h-px flex-1 bg-stone group-hover:bg-sage transition-colors duration-500" />
              </div>
              <h3 className="font-serif font-light text-charcoal text-2xl md:text-3xl leading-snug">
                {item.title}
              </h3>
              <p className="mt-4 text-charcoal/70 leading-relaxed">{item.body}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default WhyChoose;
